// import Icon from '@ant-design/icons';
import React, { useState, useEffect } from "react";
import { Spin, message } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import axios from "../../utils/BasicAuthAPI";
import { Tabs, Radio, Row, Col } from "antd";
import LineGraph from "./Common/Graph/LineGraph";
import BasicBarGraph from "./Common/Graph/BasicBarGraph";
import ColoredBarGraph from "./Common/Graph/ColoredBarGraph";
import GaugeGraph from "./Common/Graph/GaugeGraph";

import "./managerDashboard.css";
import liracrypt from "../Liracrypt/liracrypt";
import SessionError from "../ApiErrorComp/SessionError";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";

const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const boxShadow = "5px 5px 14px #181818,-5px -5px 14px #343434";

class ManagerDashboardMultiParam extends React.Component {
  state = {
    mainData: null,
    dailyTrend: null,
    // hourlyTrend: null,
    linePref: null,
    mtdData: null,
    loading: true,
    loginError: false,
    selectedTab: null,
    lid: "lid_999",
    tabsData: null,
    listData: null
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  onChange = (e) => {
    
    const st = this;
    this.setState({
      ...this.state,
      selectedTab: e.target.value,
      loading: true,
    });
    // this.fetchTrendData(e.target.value);
    this.fetchTrendData(e.target.value["cat"]);
    
  };

  changeLid = (lid) => {
    this.setState({ ...this.state, lid: lid });
    this.fetchTrendData(this.state.selectedTab, lid);
  };

  clearCache() {
    
    var listCacheKeys = [
      "DefectIdame",
      "DefectLogTypes",
      "machine",
      "bom",
      "BomXXX",
      "Employee_idame",
    ];
    for (var i = 0; i < listCacheKeys.length; i++) {
      var cacheItem = listCacheKeys[i];
      
      window.localStorage.removeItem(cacheItem);
    }
  }

  getTabs() {
    liracrypt
      .get("/dashboardtabsmultiparam", {})
      .then((response) => {
        let __tabs = response.data.data;
        this.setState(
          {
            tabsData: __tabs,
            selectedTab: __tabs.find(x => x.isDefault === true),
          },
          () => {
            if (this._isMounted && this.state.selectedTab) {
              this.fetchTrendData(this.state.selectedTab);
            }
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }

  componentDidMount() {
    
    this.clearCache();
    // this.updateMdictVersion();
    this.props.setPageHeader("Dashboard");
    this._isMounted = true;
    this.getTabs();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }

  fetchTrendData = (selectedTab, lid) => {
    liracrypt
      .get("/mdash/multiparamtrenddata", {
        lid: lid ? lid : "lid_999",
        typ: "MainGraph",
        subTyp: selectedTab["subTyp"],
      })
      .then(({ data }) => {
        
        let listData = [];
        data.data.forEach(x => {
          const newData = { ...x };
          let newDataConfig = {};
          newDataConfig["dailyTrend"] = newData["trend_D"];
          // newDataConfig["hourlyTrend"] = newData["data"]["trend_H"];
          newDataConfig["linePref"] = newData["linePerf"];
          newDataConfig["mtdData"] = [
            {
              _id: "m3",
              val: newData["m3"],
              color: "#fd9644",
            },
            {
              _id: "m2",
              val: newData["m2"],
              color: "#fd9644",
            },
            {
              _id: "m1",
              val: newData["m1"],
              color: "#fd9644",
            },
            {
              _id: "MTD",
              val: newData["mtd"],
              color: "#fd9644",
            },
            {
              _id: "YEST",
              val: newData["yest"],
              color: "#fd9644",
            },
            {
              _id: "Today",
              val: newData["today"],
              color: "#fd9644",
            },
          ];
          delete newData["trend_D"];
          delete newData["trend_H"];
          delete newData["linePerf"];
          newDataConfig["mainData"] = { ...newData };
          listData.push(newDataConfig);
        });
        
        this._isMounted &&
          this.setState({ ...this.state, listData, loading: false });
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };

  render() {
    if (this.state.listData) {
      return (
        <>
          <SessionError visible={this.state.loginError} />
          <div>
            <Radio.Group
              className="managerTabs"
              value={"small"}
              onChange={this.onChange}
            >
              {this.state.tabsData &&
                this.state.tabsData.map((tab, index) => (
                  <Radio.Button
                    key={index}
                    className={tab?.label?.toLowerCase()}
                    style={{
                      backgroundColor: "#262626",
                      color: tab?.color,
                      textAlign: "center",
                      fontSize: "17px",
                      fontWeight: 600,
                      boxShadow: boxShadow,
                      maxWidth: "200px",
                    }}
                    value={tab?.subTyp}
                  >
                    {tab?.label}
                  </Radio.Button>
                ))}
            </Radio.Group>
            {(this.state.loading === false && this.state.listData) ? (
              this.state.listData.map((x, i) => (
                <div
                  key={i}
                  style={
                    {
                      // border: "2px solid " + this.state.mainData.data.color,
                      // borderRadius: "10px",
                      // border: "2px solid #3b3b3b",
                      // borderTopColor: this.state.mainData.data.color,
                      // borderTopWidth: "3px",
                    }
                  }
                >
                  <Row>
                    <Col span={4}>
                      {x.mainData && x.mainData.icon ? (
                        <div
                          style={{
                            marginTop: "10px",
                            padding: "0px",
                            // boxShadow:
                            //   "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
                            // borderRadius: "10px",
                          }}
                        >
                          <div
                            style={{
                              height: "150px",
                              margin: "0px",
                              padding: "10px",
                              boxShadow:
                                "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
                              borderRadius: "10px",
                            }}
                          >
                            <div
                              style={{
                                display: "inline-block",
                                padding: "10px",
                                width: "100%",
                                textAlign: "center"
                              }}
                            >
                              <span
                                style={{
                                  color: "#b1b0b5",
                                  fontSize: "20px",
                                  fontWeight: 600,
                                }}
                              >
                                {/* {this.state.mainData.data.mainValPerc} */}
                                {`${x.mainData.name}${" ("}${x.mainData.uom
                                  }${")"}`}


                              </span>
                            </div>
                          </div>

                          {x.mainData &&
                            typeof (x.mainData.mainValPerc) === 'number' &&
                            <GaugeGraph
                              divId={"MainValPerc" + i}
                              barColor={x.mainData.color}
                              labelText={x.mainData.mainValPerc.toString()}
                              labelColor={x.mainData.color}
                            />
                          }
                        </div>
                      ) : null}
                    </Col>
                    <Col span={7}>
                      {x.mtdData ? (
                        <BasicBarGraph
                          divId={"mtdData" + i}
                          title={"Monthly Performance"}
                          themeColor={x.mainData.color}
                          colorMtd={x.mainData.colorMtd}
                          barkey={"val"}
                          category={"_id"}
                          data={x.mtdData}
                        />
                      ) : null}
                    </Col>
                    <Col span={13}>
                      {x.dailyTrend ? (
                        <LineGraph
                          divId={"linegraph01" + i}
                          title={"Daily Performance"}
                          legend1={"Current Month Daily Performance"}
                          legend2={"Last Month Daily Performance"}
                          lineTwoValue={"lastMonth"}
                          lineTwoColor={"#e91e63"}
                          lineOneColor={x.mainData.colorMtd}
                          lineOneValue={"mtd"}
                          category={"_id"}
                          data={x.dailyTrend}
                        />
                      ) : null}
                    </Col>
                    <div style={{ borderTop: "2px solid #3c3c3c ", marginLeft: 20, marginRight: 20, marginTop: 60, }}></div>
 
                  </Row>

                </div>
                
              ))
            ) : (
              <div className="Loading" style={{ minHeight: "100vh" }}>
                <Spin indicator={antIcon} />
              </div>
            )}
          </div>
          <div style={{ borderTop: "2px solid #3c3c3c ", marginLeft: 20, marginRight: 20, marginTop: 20, }}></div>
        </>
      );
    } else {
      return (
        <>
          {" "}
          <SessionError visible={this.state.loginError} />
          <div className="contentEmpty"></div>
        </>
      );
    }
  }
}

export default ManagerDashboardMultiParam;
